


















import { computed, defineComponent, PropType, ref, watch } from '@nuxtjs/composition-api';
import { DiscountProgress } from '@shared/composables/useShopifyDiscounts';
import { calculateProgressPercent } from '@shared/composables/useShopifyDiscounts/helpers';
import { productGetters } from '@unified-commerce/gpc-vue-storefront-shopify';

import CartFreeGift from './CartFreeGift.vue';
import DiscountProgressBar from './DiscountProgressBar.vue';

const TRANSITION_DELAY = 1000;

enum State {
  HIDDEN,
  IN_PROGRESS,
  CONDITIONS_MET,
}

export default defineComponent({
  name: 'CartFreeGiftProgress',
  components: { DiscountProgressBar, CartFreeGift },
  props: {
    discountProgress: {
      type: Object as PropType<DiscountProgress>,
      default: null,
    },
  },
  setup({ discountProgress }) {
    const state = ref(State.HIDDEN);

    const progress = computed(() => calculateProgressPercent(discountProgress));
    const numberGiftsEligibleFor = computed(() => discountProgress.numberGiftsEligibleFor);
    const progressLabel = computed(
      () =>
        `Buy ${
          discountProgress.nextRewardLevel - discountProgress.counter
        } more ${discountProgress.discount.qualifyingProducts
          .map(({ title }) => title)
          .join(' or ')} for a free gift!`,
    );

    watch(
      [progress, numberGiftsEligibleFor],
      ([progress, numberGiftsEligibleFor]) => {
        if (numberGiftsEligibleFor > 0) {
          setTimeout(() => (state.value = State.CONDITIONS_MET), TRANSITION_DELAY);
        } else if (progress > 0 && progress < 100) {
          state.value = State.IN_PROGRESS;
        } else {
          state.value = State.HIDDEN;
        }
      },
      { immediate: true },
    );

    return {
      state,
      State,
      progress,
      progressLabel,
      productGetters,
    };
  },
});
